import { createPinia, PiniaVuePlugin } from 'pinia';
import Vue from 'vue';
// import VueSSE from 'vue-sse';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
// import VueCompositionAPI from '@vue/composition-api'
// import Toast from "vue-toastification"
// import "vue-toastification/dist/index.css"
// import VueFormulate from '@braid/vue-formulate';
import '@koumoul/vjsf/lib/VJsf.css';
import VJsf from '@koumoul/vjsf/lib/VJsf.js';
// import { Crisp } from "crisp-sdk-web";
// import VueMatomo from 'vue-matomo';
import VueSplash from 'vue-splash';
import { setAuthExpiredHandler } from './axios-config';
import { useUserStore } from './store/user';
import { startVersionWatch } from './utils/versionWatch';
import { SESSION_STORAGE_KEYS } from './utils/authSession';

// import VueCookieAcceptDecline from 'vue-cookie-accept-decline';
// Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)

// Crisp.configure("603def4f-230d-494b-9e19-ee3cc936e4d4", {autoload: false});

// Vue.use(VueMatomo, {
//   // Configure your matomo server and site by providing
//   host: 'https://camceadhub.ast.cam.ac.uk',
//   siteId: 1,

//   // Changes the default .js and .php endpoint's filename
//   // Default: 'matomo'
//   trackerFileName: 'matomo',

//   // Overrides the autogenerated tracker endpoint entirely
//   // Default: undefined
//   trackerUrl: 'https://camceadhub.ast.cam.ac.uk/matomo/matomo.php',

//   // Overrides the autogenerated tracker script path entirely
//   // Default: undefined
//   trackerScriptUrl: 'https://camceadhub.ast.cam.ac.uk/matomo/matomo.js',

//   // Enables automatically registering pageviews on the router
//   router: router,

//   // Enables link tracking on regular links. Note that this won't
//   // work for routing links (ie. internal Vue router links)
//   // Default: true
//   enableLinkTracking: true,

//   // Require consent before sending tracking information to matomo
//   // Default: false
//   requireConsent: false,

//   // Whether to track the initial page view
//   // Default: true
//   trackInitialView: true,

//   // Run Matomo without cookies
//   // Default: false
//   disableCookies: false,

//   // Enable the heartbeat timer (https://developer.matomo.org/guides/tracking-javascript-guide#accurately-measure-the-time-spent-on-each-page)
//   // Default: false
//   enableHeartBeatTimer: false,

//   // Set the heartbeat timer interval
//   // Default: 15
//   heartBeatTimerInterval: 15,

//   // Whether or not to log debug information
//   // Default: false
//   debug: false,

//   // UserID passed to Matomo (see https://developer.matomo.org/guides/tracking-javascript-guide#user-id)
//   // Default: undefined
//   userId: undefined,

//   // Share the tracking cookie across subdomains (see https://developer.matomo.org/guides/tracking-javascript-guide#measuring-domains-andor-sub-domains)
//   // Default: undefined, example '*.example.com'
//   cookieDomain: undefined,

//   // Tell Matomo the website domain so that clicks on these domains are not tracked as 'Outlinks'
//   // Default: undefined, example: '*.example.com'
//   domains: undefined,

//   // A list of pre-initialization actions that run before matomo is loaded
//   // Default: []
//   // Example: [
//   //   ['API_method_name', parameter_list],
//   //   ['setCustomVariable','1','VisitorType','Member'],
//   //   ['appendToTrackingUrl', 'new_visit=1'],
//   //   etc.
//   // ]
//   preInitActions: []
// });

Vue.use(VueSplash);
// Vue.use(VueSSE);

Vue.use(PiniaVuePlugin)
export const pinia = createPinia()
// Vue.use(VueCompositionAPI)

Vue.config.productionTip = false

// The backend refused the stored sign-in (expired, signed elsewhere, one-time-code step never finished): axios-config has already
// removed it from localStorage; reset the in-memory copy and, if the page needs a person, go to the sign-in page with a note.
setAuthExpiredHandler(() => {
  try {
    useUserStore(pinia).clearSession()
  } catch (e) {
    console.warn(e)
  }
  const current = router.currentRoute
  if (current.name !== 'SignIn' && current.matched.some((r) => r.meta && r.meta.requiresAuth)) {
    router.push({ name: 'SignIn', query: { expired: '1', redirect: current.name } }).catch(() => {})
  }
})
startVersionWatch()
// Keep every open tab on the same sign-in (see syncFromStorage in the store).
window.addEventListener('storage', (e) => {
  if (e.storageArea !== window.localStorage) return
  if (e.key === null || SESSION_STORAGE_KEYS.includes(e.key)) {
    try {
      useUserStore(pinia).syncFromStorage()
    } catch (err) {
      console.warn(err)
    }
  }
})

Vue.component('VJsf', VJsf)

// Vue.use(Toast);
// Vue.use(VueFormulate);

new Vue({
  router,
  vuetify,
  pinia,
  render: h => h(App)
}).$mount('#app')
